<template>
    <v-tooltip bottom :disabled="!obj.schema.disabled" open-on-hover content-class="myprovet-tooltip">
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
                <v-autocomplete v-bind="{ ...obj.schema }" v-on:input="onUpdate($event)" :value="value">
                    <template v-slot:prepend-item v-if="obj.schema.multiple">
                        <v-list-item ripple @click="onSelectAll(!checkedSelectAll)">
                            <v-list-item-action>
                                <v-checkbox light v-model="checkedSelectAll" @click="onSelectAll(!checkedSelectAll)"></v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                                <v-list-item-title>{{ $t('clientMenu.selectAll') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                    </template>

                    <template v-slot:item="{ item, attrs, on }">
                        <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                            <v-list-item-action v-if="obj.schema.multiple">
                                <v-checkbox :input-value="active"></v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                                <v-list-item-title>{{ displayText(item) }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>

                    <template v-slot:selection="data">
                        <span v-if="data && data.index === 0" class="truncate-text">{{
                            !data.parent.multiple
                                ? displayText(data.item)
                                : data.parent.initialValue && data.parent.initialValue.length > 1
                                    ? $tc('clientMenu.selectedCount', multipleSelectedCounter(data.parent.initialValue), { n: multipleSelectedCounter(data.parent.initialValue) })
                                    : displayText(data.item)
                        }}</span>
                    </template>
                </v-autocomplete>
            </div>
        </template>

        <span class="font-size-md"> {{ textToDisplay }}</span>
    </v-tooltip>
</template>

<script>
export default {
    props: ['type', 'value', 'obj', 'dataIsHomologousPeriod'],

    data() {
        return {
            previousItems: [],
            comparisonKey: '',

            selectedItems: [],
            checkedSelectAll: false,
            aggregatorIndex:0
        };
    },

    computed: {
        textToDisplay() {
            if (this.dataIsHomologousPeriod) {
                return this.$t('clientMenu.needsDates');
            }

            return this.$t('clientMenu.notWithAdvanced');
        },
    },

    mounted() {
        window.EventBus.$on('removed-active-filter', () => {
            if (!('dataFieldAggregators' in this.obj.schema)) return;

            // If the current filter has an aggregator, we might want
            //  to remove it depending on the item that was removed.
            this.onUpdate(this.value);
        });
    },

    beforeDestroy() {
        window.EventBus.$off('removed-active-filter');
    },

    methods: {
        // The text shown for an item, translated when the backend sent it in pt
        displayText(item) {
            const key = this.obj.schema.itemText;
            const text = item !== null && typeof item === 'object' && key && item[key] !== undefined ? item[key] : item;

            return this.tb(`${text}`);
        },

        hasItemActive(items, item) {
            const key = this.comparisonKey;

            let index = items.findIndex((x) => x[key] === item[key]);
            return index !== -1;
        },

        removeActiveItem(items, item) {
            const key = this.comparisonKey;

            let index = items.findIndex((x) => x[key] === item[key]);
            if (index !== -1) items.splice(index, 1);
        },

        hasAllAggregatorItems(aggregatorItems, items) {
            for (const aggregatorItem of aggregatorItems) {
                if (!this.hasItemActive(items, aggregatorItem, this.comparisonKey)) {
                    return false;
                }
            }

            return true;
        },

        hasAllItems(items, aggregatorField, numberOfAggregators) {

            if(aggregatorField==='LAB RAPPEL' && items.length>1){
                localStorage.setItem('aggregatorIndex', 0);
            }
            if ('dataFieldAggregators' in this.obj.schema) {
                const aggregators = this.obj.schema.dataFieldAggregators;
                const aggregatorFields = Object.keys(aggregators);
                items = items.filter((it) => !_.some(aggregatorFields, b => it.name.includes(b)));
            }else{
                items = items.filter((it) => it.name !== aggregatorField);
            }
            this.selectedItems = items;

            return (this.checkedSelectAll = this.selectedItems.length === this.obj.schema.items.length - numberOfAggregators);
        },

        wasActivated(aggregatorKey, items, aggregator) {
            // @Order
            if (this.checkedSelectAll) return false;
            if (this.hasItemActive(this.previousItems, aggregator)) return false;
            if (this.hasItemActive(items, aggregator)) return true;

            return false;
        },

        wasDeactivated(aggregatorKey, items, aggregator) {
            // @Order
            if (this.checkedSelectAll) return false;
            if (this.hasItemActive(items, aggregator)) return false;
            if (this.hasItemActive(this.previousItems, aggregator)) return true;

            return false;
        },

        onUpdate(items) {
            const numberOfAggregators = Object.keys(this.obj.schema?.dataFieldAggregators ?? []).length;
            let auxAggregatorField = '';

            if ('dataFieldAggregators' in this.obj.schema && items) {

                const aggregators = this.obj.schema.dataFieldAggregators;
                this.comparisonKey = this.obj.schema.itemText;
                //if (aggregators.length > 1) throw new Error('Only one aggregator is supported at this time.');
                this.aggregatorIndex=0;
                let localStorageAggregatorIndex=JSON.parse(localStorage.getItem('aggregatorIndex'));

                if(_.size(items)===1){
                    if(items[0].name === 'LAB RAPPEL' || _.last(items).name =='LAB RAPPEL'){
                        this.aggregatorIndex=1
                        localStorage.setItem('aggregatorIndex', 1);
                    }
                }

                if(localStorageAggregatorIndex==1 &&  numberOfAggregators >1){
                    if(numberOfAggregators >1){
                        this.aggregatorIndex=1
                    }else{
                        localStorage.setItem('aggregatorIndex', 0);
                        this.aggregatorIndex=0
                    }
                }

                const aggregatorItems = Object.values(aggregators)[this.aggregatorIndex];
                const aggregatorField = Object.keys(aggregators)[this.aggregatorIndex];
                const aggregator = this.obj.schema.items.find((x) => x[this.comparisonKey] === aggregatorField);
                auxAggregatorField = aggregatorField;

                const wasActivated = this.wasActivated(aggregatorField, items, aggregator);
                const wasDeactivated = this.wasDeactivated(aggregatorField, items, aggregator);
                if (!this.hasAllItems(items, aggregatorField, numberOfAggregators)) {
                    if (!wasActivated && !wasDeactivated) {
                        if (!this.hasAllAggregatorItems(aggregatorItems, items)) {
                            if (this.hasItemActive(items, aggregator)) {
                                items.push(aggregator);
                            }
                        } else {
                            this.removeActiveItem(items, aggregator);
                        }
                    } else if (wasActivated) {
                        for (const item of aggregatorItems) {
                            if (!this.hasItemActive(items, item)) {
                                items.push(item);
                            }
                        }

                        this.selectedItems = items;
                    } else if (wasDeactivated) {
                        for (const item of aggregatorItems) {
                            this.removeActiveItem(items, item);
                        }

                        this.selectedItems = items;
                    }

                    this.previousItems = JSON.parse(JSON.stringify(items));
                }

                if (this.checkedSelectAll) {
                    this.selectedItems = items.filter((it) => it.name !== aggregatorField && it.name!='LAB RAPPEL');
                }
            } else {
                this.hasAllItems(items, auxAggregatorField, numberOfAggregators);
            }

            this.$emit('input', this.selectedItems);
        },

        onSelectAll(checked) {
            this.checkedSelectAll = checked;

            if (checked) {
                this.onUpdate(this.obj.schema.items);
            } else {
                this.onUpdate([]);
                this.previousItems = [];
            }
        },

        multipleSelectedCounter(items) {
            // @Note: Remove aggregator from checked options counter
            if ('dataFieldAggregators' in this.obj.schema && items) {
                const aggregators = this.obj.schema.dataFieldAggregators;
                //if (aggregators.length > 1) throw new Error('Only one aggregator is supported at this time.');
                const aggregatorField = Object.keys(aggregators);

                return items.filter((it) => !_.some(aggregatorField, b => it.name.includes(b))).length;
            } else {
                return items.length;
            }
        },
    },
};
</script>

<style>
.truncate-text {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}
</style>
